import { render, staticRenderFns } from "./WXCW81MyProject.vue?vue&type=template&id=656d0208&scoped=true&"
import script from "./WXCW81MyProject.vue?vue&type=script&lang=js&"
export * from "./WXCW81MyProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656d0208",
  null
  
)

export default component.exports